import { useTelegramUserStore } from '../../store/useTelegramUserStore'
import styles from './UserInfoTop.module.css'

const UserInfoTop = () => {

    const user = useTelegramUserStore((state) => state.user)

    return (
        <div className={styles.userInfoWrapper}>
            <div className={styles.userInfoContainer}>
                <div className={styles.userInfoContainer__pfp}>
                    <img src={user?.photo_url} alt="pfp" />
                </div>
                <div className={styles.userInfoContainer__name}>
                    {user?.username}
                </div>
            </div>
            <div className={styles.coinWrapper}>
                <div className={styles.coinContainer}>
                    <div className={styles.coinContainer__icon}>

                    </div>
                    <div className={styles.coinContainer__coins}>
                        75
                    </div>
                    <div className={styles.coinContainer__chevron}>
                        <div className={styles.chevron}></div>
                    </div>
                </div>
                <div className={styles.coinContainer}>
                    <div className={styles.ticketsContainer__icon}>

                    </div>
                    <div className={styles.ticketsContainer__tickets}>
                        122
                    </div>
                </div>
                <div className={styles.coinContainer}>
                    <div className={styles.snipperBallContainer__icon}>

                    </div>
                    <div className={styles.ticketsContainer__tickets}>
                        0
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UserInfoTop